import {
  type CompanyListInput,
  type CompanyListSuccess,
  DAY,
  isEmpty,
  isTantalim,
  type TinyCompany,
} from '@terros/common'
import { useTantalimQuery } from '../query'
import { companyListKey } from '../keys'
import { type GetHookResponse } from '../hooks'

export function useCompanies(props?: CompanyListInput, enabled = true): GetHookResponse<TinyCompany[]> {
  return useTantalimQuery<CompanyListInput, CompanyListSuccess, TinyCompany[]>({
    url: '/company/list',
    queryKey: companyListKey(props),
    input: props ?? {},
    convertResponse: (data) => data.companies,
    options: {
      gcTime: DAY,
      staleTime: DAY,
      enabled,
    },
  })
}

export type SortableCompany = Pick<TinyCompany, 'companyId' | 'kind' | 'accessStatus' | 'name'>

function getSortPriority(company: SortableCompany): number {
  if (company.accessStatus === 'suspended') return 2
  if (company.kind === 'demo') return 0
  return 1
}

export function sortCompanies(companies: SortableCompany[] | undefined): void {
  if (isEmpty(companies)) return
  companies.sort((a, b) => {
    if (isTantalim(a)) return -1
    if (isTantalim(b)) return 1
    const priorityDiff = getSortPriority(a) - getSortPriority(b)
    if (priorityDiff !== 0) return priorityDiff
    return a.name.localeCompare(b.name)
  })
}
